import { datadogLogs } from "@datadog/browser-logs";
import { getKioskId } from "../../lib/kiosk-identity";
import type { KioskMachineContext } from "../../machine/types";

type PaymentStatus = "success" | "failure" | "none";

const STATE_TO_PAYMENT_STATUS: Record<string, PaymentStatus> = {
  completePayment: "success",
  completeCardOnFile: "success",
  completeDefault: "success",
  completeWorkersCompEPSOrTravel: "success",
  completePayLater: "none",
  completeFrontDesk: "none",
  failed: "failure",
};

export function logFlowCompleteAction(
  stateName: string,
): (args: { context: KioskMachineContext }) => void {
  return ({ context }) => {
    const paymentStatus = STATE_TO_PAYMENT_STATUS[stateName] ?? "none";
    datadogLogs.logger.info("kiosk flow complete", {
      context: {
        action: "kiosk_flow_complete",
        metadata: {
          outcome: stateName,
          paymentStatus,
          consumerId: context.consumerId ?? null,
          orgId: context.orgId ?? null,
          paymentIntentId: context.paymentIntentId ?? null,
          stripeTerminalId:
            paymentStatus !== "none" ? (context.stripeReaderId ?? null) : null,
          kioskId: getKioskId(),
        },
      },
    });
  };
}
